import React from 'react';
import Wrapper from './Wrapper.jsx';
import classNames from 'class-names';

const Basic = (props) => {
	const {
		type,
		name,
		onChange,
		placeholder,
		value,
		text,
		errors = [],
		disabled = false,
	} = props;
	// console.table({name, value})
	const classes = classNames({
		'has-error': errors.length > 0,
	});
	return (
		<Wrapper {...props}>
			<input
				type={type}
				className={classes}
				name={name}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				disabled={disabled}
			/>
			{text}
		</Wrapper>
	);
};

export default Basic;